import React from 'react'


function Hero() {
    return (
        <div className='container p-5'>
            <div className='row text-center'>
                <img src='media/homeHero.png' alt='Hero img' className='mb-3'/>
                <h3 className='mt-3'>Invest in everything</h3>
                <p>Online platform to invest in stocks, derivatives, mutual funds, ETFs, bonds, <b>signup in Kite only</b></p>
                <a href="signup">
                    <button className='p-3 btn btn-primary fs-5 mb-5' style={{width: "20%", margin: "0 auto"}}>Signup Now</button>
                </a>
            </div>
        </div>
    );
}

export default Hero;